import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTableComponent } from '../pages/data-table/data-table.component';
import { PrimengModule } from '../pages/primeng.module';
import { AutoFocusDirective } from 'app/directives/auto-focus/auto-focus.directive';
import { CanPerformDirective } from 'app/directives/permission/can-perform.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditorComponent } from './editor/editor.component';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { SafeImageUrlPipe } from 'app/utils/pipes/safe-image-url.pipe';
import { LoaderComponent } from './loader/loader.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { CoreDirectivesModule } from '@core/directives/directives';
import { IdCardComponent } from './id-card/id-card.component';
import { TranslateModule } from '@ngx-translate/core';

// Directives
import { DynamicLabelDirective } from '../../directives/dynamic-label/dynamic-label.directive';

// Pipes
import { DynamicLabelPipe } from '../../pipes/dynamic-label.pipe';
import { ColumnTranslatePipe } from '../../pipes/column-translate.pipe';

// Services
import { SchoolContextService } from '../../services/school/school-context.service';
import { DynamicLabelService } from '../../services/school/dynamic-label.service';
import { DynamicMenuService } from '../../services/school/dynamic-menu.service';
import { SchoolContextDemoComponent } from './school-context-demo/school-context-demo.component';
import { StatisticsMetricCardComponent } from './statistics/statistics-metric-card/statistics-metric-card.component';
import { StatisticsChartCardComponent } from './statistics/statistics-chart-card/statistics-chart-card.component';
import { TransferLearnerClassDialogComponent } from './transfer-learner-class-dialog/transfer-learner-class-dialog.component';

const components = [
  IdCardComponent,
  CanPerformDirective,
  AutoFocusDirective,
  SafeImageUrlPipe,
  DataTableComponent,
  EditorComponent,
  LoaderComponent,
  NotificationsComponent,
  ColumnTranslatePipe,
  StatisticsMetricCardComponent,
  StatisticsChartCardComponent,
  TransferLearnerClassDialogComponent,
];

@NgModule({
  declarations: [...components, DynamicLabelDirective, DynamicLabelPipe, SchoolContextDemoComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    TranslateModule,
    PrimengModule,
    CoreDirectivesModule,
  ],
  exports: [...components, PrimengModule, DynamicLabelDirective, DynamicLabelPipe, TranslateModule, TransferLearnerClassDialogComponent],
  providers: [
    SchoolContextService,
    DynamicLabelService,
    DynamicMenuService,
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
  ],
})
export class SharedModule {}
